import { render, staticRenderFns } from "./one.vue?vue&type=template&id=5ebef1fa"
import script from "./one.vue?vue&type=script&lang=js"
export * from "./one.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports